// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  apiUrl: 'https://api-teszt.slmsystem.hu',
  defaultLanguage: 'hu',
  recaptchaSiteKey: '6Lf36-wZAAAAAMdzgr-f403VzlRLTSeZ--Eem9ft',
  showRights: false,
  errorReload: false,
  aggreg8ApiUrl: 'https://a8-sync-ui.sandbox.aggreg8.hu?token='
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
